import { render, staticRenderFns } from "./Noahs_Orders.vue?vue&type=template&id=282fd5b1&scoped=true"
import script from "./Noahs_Orders.vue?vue&type=script&lang=js"
export * from "./Noahs_Orders.vue?vue&type=script&lang=js"
import style0 from "./Noahs_Orders.vue?vue&type=style&index=0&id=282fd5b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282fd5b1",
  null
  
)

export default component.exports